import { Award, ShieldCheck, MapPin, Building2, Sparkles } from 'lucide-react'
const LanzaderaBanner = () => {
  return (
    <section
      id="lanzadera"
      className="py-14 relative bg-[#021c19] border-y border-[#00FF9D]/15 overflow-hidden"
    >
      {/* Background soft ambient glow */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3/4 h-32 rounded-full blur-3xl opacity-20 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse, #00FF9D 0%, #05332E 100%)',
        }}
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-6">
          <span className="text-xs uppercase font-mono tracking-widest text-[#00FF9D] font-bold flex items-center justify-center gap-2">
            <Sparkles className="w-3.5 h-3.5" />
            Impulsados por el mayor ecosistema de emprendimiento e innovación de
            España
          </span>
        </div>

        {/* Card destacada de autoridad */}
        <div className="max-w-4xl mx-auto bg-[#05332E]/70 hover:bg-[#05332E]/90 border border-[#00FF9D]/30 rounded-2xl p-6 sm:p-8 backdrop-blur-md shadow-[0_10px_35px_rgba(0,0,0,0.5)] transition-all duration-300">
          <div className="flex flex-col md:flex-row items-center gap-6 sm:gap-8">
            {/* Lanzadera Brand Emblem */}
            <div className="flex-shrink-0 flex flex-col items-center justify-center p-5 rounded-xl bg-[#012622] border border-[#00FF9D]/30 shadow-inner w-full md:w-56 text-center">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-9 h-9 rounded-lg bg-[#00FF9D]/15 border border-[#00FF9D]/50 flex items-center justify-center text-[#00FF9D]">
                  <Award className="w-5 h-5" />
                </div>
                <div className="text-left">
                  <span className="text-lg font-black tracking-tight text-white block leading-none">
                    LANZADERA
                  </span>
                  <span className="text-[10px] text-[#00FF9D] font-mono tracking-wider uppercase font-semibold">
                    Marina de Empresas
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-1.5 text-[11px] text-[#CBD5E1] pt-2 border-t border-[#0A3F39] w-full justify-center">
                <ShieldCheck className="w-3.5 h-3.5 text-[#00FF9D]" />
                <span className="font-semibold text-white">
                  Startup Acelerada
                </span>
              </div>
            </div>

            {/* Authoritative description */}
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-lg sm:text-xl font-bold text-white mb-2 flex items-center justify-center md:justify-start gap-2">
                <span>Respaldo Institucional & Excelencia Operativa</span>
                <span className="hidden sm:inline-block px-2 py-0.5 rounded text-[10px] font-mono bg-[#00FF9D]/20 text-[#00FF9D] border border-[#00FF9D]/30">
                  Valencia, España
                </span>
              </h3>
              <p className="text-sm sm:text-base text-[#CBD5E1] leading-relaxed">
                <strong className="text-white font-semibold">Hutrit</strong> es
                una startup acelerada por{' '}
                <strong className="text-[#00FF9D] font-semibold">
                  Lanzadera
                </strong>
                , la iniciativa impulsada por{' '}
                <strong className="text-white font-semibold">Juan Roig</strong>{' '}
                (fundador de Mercadona) en{' '}
                <strong className="text-white font-semibold">
                  Marina de Empresas
                </strong>{' '}
                (Valencia). Un sello de garantía, solvencia técnica y
                ejecuciones de alto impacto.
              </p>

              {/* Badges footer */}
              <div className="flex flex-wrap items-center justify-center md:justify-start gap-4 mt-4 pt-3 border-t border-[#0A3F39]/60 text-xs font-mono text-[#CBD5E1]">
                <span className="flex items-center gap-1.5">
                  <MapPin className="w-3.5 h-3.5 text-[#00FF9D]" />
                  Marina de Empresas (Valencia)
                </span>
                <span className="flex items-center gap-1.5">
                  <Building2 className="w-3.5 h-3.5 text-[#00FF9D]" />
                  Ecosistema Juan Roig
                </span>
                <span className="flex items-center gap-1.5 text-[#00FF9D]">
                  <ShieldCheck className="w-3.5 h-3.5 text-[#00FF9D]" />
                  Verificación de Calidad SaaS
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
export { LanzaderaBanner }
